











import Vue from 'vue';
import * as moment from 'moment';
import 'moment/locale/pt-br';
import Customer from '../../../models/Customer';
import { sceneItems, SceneItem } from '../../../models/CustomerFilter';

export default Vue.extend({
  props: {
    customer: Customer,
  },
  computed: {
    displayTime(): string {
      moment.locale('zh-cn');
      const time = this.customer.wxProps.subscribeTime;
      return moment(time, 'YYYY-MM-DD HH:mm:ss').fromNow();
    },
    displayScene(): string | null {
      if (this.customer.wxProps.subscribeScene) {
        const v = Object.values(sceneItems).find((v: SceneItem) => {
          return v.value === this.customer.wxProps.subscribeScene;
        });
        if (v) {
          return v.label;
        }
      }
      return null;
    },
  },
});
